/** Shopify CDN: Minification failed

Line 15:2 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 20:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 31:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 35:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 45:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 59:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('text-animation')) {
  class TextAnimation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.settings = {
        appearThreshold: 0.3,
        hideOutViewport: false
      }

      this.headingWrapper = Array.from(this.querySelectorAll('.image-content__heading-wrapper'))

      this.init();
    }

    init() {
      this.observer(this);
    }

    observer(element) {
      this.observerInstance = new IntersectionObserver(this.effectBinder.bind(this), {
        threshold: this.settings.appearThreshold
      });

      this.observerInstance.observe(element);
    }

    effectBinder(entries) {
      const inViewport = entries[0].isIntersecting;
      const element = entries[0].target;

      if (inViewport) {
        // element.setAttribute('data-visible', true);
        element.classList.add('animate-step-first');

        this.listener();

      } else if (this.settings.hideOutViewport && !inViewport) {
        element.removeAttribute('data-visible');
        element.classList.remove('animate-step-first');
      }
    }

    listener() {
      this.headingWrapper.forEach((element) => {

        element.querySelector('.image-content__heading').addEventListener('transitionend', () => {
          element.classList.add('animate-step-second');
          document.querySelector('body').classList.add('text-animation-done')

            if (element.classList.contains('animate-step-second')) {
              setTimeout(() => {
                element.classList.add('animate-step-second-done');
              }, 1600)
            }
        }, {once: true});
      });
    }
  }

  customElements.define('text-animation', TextAnimation);
}
